<template>
  <keep-alive>
    <router-view></router-view>
  </keep-alive>
</template>

<script>
  export default {}
</script>



// WEBPACK FOOTER //
// src/pages/GroupWithKeepAlive.vue